/**
 * Route names enumeration for type-safe route navigation
 * All route names should be defined here to maintain consistency
 *
 * NOTE: This is in a separate file from app.routes.ts to avoid circular
 * dependencies (guards import ROUTE_NAMES, and app.routes.ts imports guards).
 */
export enum ROUTE_NAMES {
  ROOT = '/',
  NO_SELECTED_ROUTE = 'no-selected-route',
  OVERVIEW = 'overview',
  FAULT_ANALYSIS = 'fault-analysis',
  SYSTEM_HEALTH = 'system-health',
  FAULT_RECOMMENDATIONS = 'fault-recommendations',
  TROUBLESHOOTING = 'troubleshooting',
  MACHINE_OVERVIEW = 'machine-overview',
  SETTINGS = 'settings',
  REMOTE_ACCESS = 'remote-access',
  LICENSING = 'licensing',
  MODEL_FEEDBACKS = 'model-feedbacks',
}
